/// <reference path="FormatLookupEditor.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class ListEditor extends FormatLookupEditorBase<ListEditorOptions, ListItemRow> {

        private myLookup: Q.Lookup<ListItemRow>;

        constructor(input: JQuery, opt: ListEditorOptions) {
            super(input, opt);
        }

        updateItems() {
            this.myLookup = null;
            super.updateItems();
        }

        protected getLookup() {
            if (!this.myLookup) {
                var items = ListItemRow.getLookup().items.filter(x => x.ListCode == this.options.listCode);
                items.sort((x, y) => x.DefaultSortOrder < y.DefaultSortOrder ? -1 :
                    (x.DefaultSortOrder > y.DefaultSortOrder) ? 1 : Q.turkishLocaleCompare(x.ListItemText, y.ListItemText));
                this.myLookup = new Q.Lookup({
                    idField: ListItemRow.Fields.ListItemCode,
                    textField: ListItemRow.Fields.ListItemText
                }, items);
            }

            return this.myLookup;
        }

        protected getLookupKey() {
            return ListItemRow.lookupKey;
        }
    }

    export interface ListEditorOptions extends FormatLookupEditorOptions {
        listCode: string;
    }
}